import axios from 'axios';
import { JSEncrypt } from 'jsencrypt';

const rsaPublicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA6wG21J0U+LCJvb1g4wqGwm1TI/WxEvIpAiOdhYYOVoGAhvHLPe3LYrwxAWJaRSM/R4zrBFrDrZotwGee2I15wcejQNQbDCOlIx1Jer57ero7iVHlwbuT1taCZeEY6mGOv/4mN61WcSR6I0J3Sn/wcsZ76puzcQIytGeUhqHg9aAEQHJc4Hj2+bf22t20zEzWkX1RdALKInDUTwvRutl+y4QERknqQdfNx5+wWtnBPf/POB/QvHkUKHHqYJg4hx+9CRVdUr5VaLpNfyLf0n8CSghrUu4b/fNbnn5tRt22xwh0YL7cob+ajELApTMTux9SPkYtzYBQoGgT6ICbhpyVtQIDAQAB';

// 获取用户token 该方法只适用于access_token的方式鉴权，等后端鉴权改变
// const accessToken = () => {
//   const token = localStorage.getItem('access_token')
//   return token || ''
// }
// let user

// 生成带时间戳的加密鉴权串
export function authCode(originAuthCode) {
  if (!rsaPublicKey) {
    throw new Error('RSA 公钥未设置');
  }
  const timestamp = Date.now().toString();
  const plainText = `${originAuthCode}|${timestamp}`;
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(rsaPublicKey);
  const encrypted = encryptor.encrypt(plainText);
  if (!encrypted) {
    throw new Error('RSA 加密失败');
  }
  return encrypted;
}

// XmlHttpRequest根路径
const baseUrl = '/webapi/v1';

/**
 * 创建ajax请求
 * @param {*} options
 * options.url: 请求url
 * options.method: POST/GET  默认POST
 * options.data: 请求的数据
 */
function createHttp(options = {}) {
  const instance = axios.create();
  // Axios的实例的基础配置
  instance.defaults.method = options.method || 'POST';
  instance.defaults.baseURL = baseUrl;
  instance.defaults.timeout = 0;
  instance.defaults.responseType = options.responseType || 'json';
  // instance.defaults.headers.common.Authorization = accessToken()
  instance.defaults.validateStatus = (status) => {
    const result = status !== 401 && status !== 500;
    return result;
  };
  // 配置请求信息
  instance.interceptors.request.use((config) => {
    config.headers['Content-Type'] = options.contentType || 'application/json; charset=UTF-8';
    config.headers.Authorization = localStorage.getItem('authorization');
    const token = localStorage.getItem('authorization');
    if (token) {
      config.headers['X-Auth-Code'] = authCode(token);
    }
    return config;
  }, (error) => {
    // Do something with request error
    Promise.reject(error);
  });
  // 处理返回信息
  instance.interceptors.response.use((res) => {
    // Do something with response data
    if (res.data.code !== 200 && res.data.code !== 401 && res.data.code !== 403 && res.data.code !== 601) {
      this.$notify.error({
        title: '提示',
        dangerouslyUseHTMLString: true,
        message: res.data.msg
      });
    } else if (res.data.code === 200) {
      if (options.prompt) {
        this.$notify.success({
          title: '提示',
          message: res.data.msg
        });
      }
      return res.data;
    } else if (res.data.code === 601) {
      return res.data;
    } else if (res.data.code === 401 || res.data.code === 403) {
      localStorage.removeItem('account');
      localStorage.removeItem('permissions');
      localStorage.removeItem('authorization');
      this.$notify.error({
        title: '提示',
        message: res.data.msg,
        onClose() {
          location.href = '/';
        }
      });
    }
    return Promise.reject(new Error(res.data.msg));
  }, (error) => {
    const res = error.response;
    // Do something with response error
    if (res && res.status === 401) {
      // localStorage.removeItem('access_token');
      location.href = '/';
    } else if (res && res.status === 500) {
      // eslint-disable-next-line
      alert('服务器内部错误');
    } else if (res && res.status === 502) {
      this.$notify.success({
        title: '提示',
        message: '网关错误'
      });
    }
    Promise.reject(new Error('发生了错误'));
  });
  return instance(options);
}

function download(options) {
  const instance = axios.create();
  instance.defaults.baseURL = baseUrl;
  instance.defaults.method = options.method || 'GET';
  instance.defaults.responseType = options.responseType || 'blob';
  // 配置请求信息
  instance.interceptors.request.use((config) => {
    config.headers['Content-Type'] = options.contentType || 'application/json; charset=UTF-8';
    config.headers.Authorization = localStorage.getItem('authorization');
    return config;
  }, (error) => {
    // Do something with request error
    Promise.reject(error);
  });
  instance(options).then((res) => {
    // 这里res.data是返回的blob对象
    const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }); // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
    const downloadElement = document.createElement('a');
    const href = window.URL.createObjectURL(blob); // 创建下载的链接
    downloadElement.href = href;
    downloadElement.download = options.name || 'xxx.xlsx'; // 下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); // 点击下载
    document.body.removeChild(downloadElement); // 下载完成移除元素
    window.URL.revokeObjectURL(href); // 释放掉blob对象
  });
}

function downloadVoice(options) {
  const instance = axios.create();
  instance.defaults.baseURL = baseUrl;
  instance.defaults.method = options.method || 'GET';
  instance.defaults.responseType = options.responseType || 'blob';
  // 配置请求信息
  instance.interceptors.request.use((config) => {
    config.headers['Content-Type'] = options.contentType || 'application/json; charset=UTF-8';
    config.headers.Authorization = localStorage.getItem('authorization');
    return config;
  }, (error) => {
    // Do something with request error
    Promise.reject(error);
  });
  return instance(options);
}
async function downSplit(options) {
  const fileTmps = options.path.split('/');
  const url = `${baseUrl}${options.url}?filePath=${options.path}`;
  const fileName = fileTmps[fileTmps.length - 1];
  const chunkSize = 1024 * 1024 * 5; // 5MB
  let start = 0;
  let end = chunkSize - 1;
  let fileSize = 0;
  const chunks = [];
  const headConfig = {
    headers: {
      Authorization: localStorage.getItem('authorization')
    }
  };
  // Get file size
  const response = await axios.head(url, headConfig);
  fileSize = response.headers['content-length'];
  // Calculate number of chunks
  const numChunks = Math.ceil(fileSize / chunkSize);
  if (fileSize < chunkSize) {
    end = fileSize - 1;
  }
  // Download chunks
  for (let i = 0; i < numChunks; i++) {
    const range = `bytes=${start}-${end}`;
    const config = {
      headers: {
        'Content-Type': 'application/json; application/octet-stream',
        'Authorization': localStorage.getItem('authorization'),
        'Range': range
      },
      responseType: 'blob'
    };
    // eslint-disable-next-line no-await-in-loop,no-shadow
    const response = await axios.get(url, config);
    chunks.push(response.data);
    start = end + 1;
    end = Math.min(end + chunkSize, fileSize - 1);
  }

  // Combine chunks into a single file
  const blob = new Blob(chunks, { type: 'application/zip' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
}


export default (Vue) => {
  // ajax配置
  Vue.prototype.$ajax = createHttp;
  Vue.prototype.$download = download;
  Vue.prototype.$url = baseUrl;
  Vue.prototype.$downloadVoice = downloadVoice;
  Vue.prototype.$downloadSplit = downSplit;
};



// WEBPACK FOOTER //
// ./src/utils/ajax.js